import {convertRowsToData} from '../utils/dataUtils'
export default function CandleStickDataController (rows) {
  
  let headers = rows[0]
  let propperHeaders = ['id','open','close','high','low']
  let data = convertRowsToData([propperHeaders,...rows.slice(1)],4)  
  
  return data.map((point)=>{
    return {
      id: point.id,
      open: +point.value.find((d)=>d.id==='open').value,
      close: +point.value.find((d)=>d.id==='close').value,
      high: +point.value.find((d)=>d.id==='high').value,
      low: +point.value.find((d)=>d.id==='low').value
    }
  })
}